<template>
  <div class="tagged">
    <template v-if="courses && courses.length">
      <div
        class="tagged__background"
        :style="
          `background-image: url(${$getCourseBackground(
            courses[0].objectID,
            'large'
          )}), linear-gradient(#151515, #262626);`
        "
      >
        <div class="tagged__overlay"></div>
      </div>
      <section class="tagged__wrapper">
        <h1 class="tagged__header">{{ selectionType }} Courses</h1>
        <div class="tagged__courses-wrapper">
          <CourseTile
            v-for="course in courses"
            :key="course.objectID"
            :course="course"
            :isFreeTrialUser="isFreeTrialUser"
          />
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { createAlgoliaIndices } from '@/utils'
import CourseTile from '@/components/layout/CourseTile.vue'

export default {
  name: 'Tagged',
  components: {
    CourseTile,
  },
  props: {
    selectionType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    algoliaKeys: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      courses: [],
    }
  },
  methods: {
    handleResults(index, { hits }) {
      this.courses = hits
    },
    createAlgoliaSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, coursesIndex: courses },
        selectionType: type,
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'Courses',
            index: courses,
            facets: [`is_${type}`],
          },
        ],
        resultsHandler: this.handleResults,
      }
      const parentFilter = {
        facet: `is_${type}`,
        value: 'true',
      }
      createAlgoliaIndices(setup, parentFilter)
    },
  },
  created() {
    this.createAlgoliaSearchInstance()
  },
  watch: {
    selectionType() {
      this.createAlgoliaSearchInstance()
    },
  },
}
</script>

<style lang="scss" scoped>
.tagged {
  &__background {
    min-height: 100vh;
    width: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.7),
      var(--dark-gray),
      var(--dark-gray)
    );
    z-index: 0;
    min-height: 100vh;
    width: 100%;
  }
  &__header {
    color: var(--white);
    text-transform: capitalize;
  }
  &__wrapper {
    position: relative;
    padding: 150px 25px;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__courses-wrapper {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 8px;
    }
    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
}
</style>
